import { t } from 'i18next';
import * as yup from 'yup';

const VETA_CENTER_TEXT_MAX_LENGTH = 20;

export default function vetaCenterTextSchema(fieldLabel: string) {
  return yup
    .string()
    .trim()
    .max(
      VETA_CENTER_TEXT_MAX_LENGTH,
      t('form_validation_errors.max_length', {
        field: fieldLabel,
        max: VETA_CENTER_TEXT_MAX_LENGTH,
      }),
    );
}
